import React from 'react';

export default function SectionBanner({ image, title }) {
  return (
    <div className="section-banner" style={{ backgroundImage: `url(${image})` }}>
      {title && (
        <div className="section-banner-title-container">
          <div className="max-width-container full-width">
            <h1 className="section-banner-title small-padding">{title}</h1>
          </div>
        </div>
      )}
    </div>
  );
}
